if (!customElements.get("nmn-reputation")) {
  customElements.define(
    "nmn-reputation",
    class extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        const viewport = this.querySelector("[data-reputation-viewport]");
        const track = this.querySelector("[data-reputation-track]");
        const logos = this.querySelector("[data-reputation-logos]");
        const pause = this.querySelector("[data-reputation-pause]");
        if (!viewport || !track || !logos || !pause) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");
        this.copy = logos.cloneNode(true);
        this.copy.removeAttribute("data-reputation-logos");
        this.copy.removeAttribute("aria-labelledby");
        this.copy.setAttribute("aria-hidden", "true");
        this.copy.setAttribute("inert", "");
        track.append(this.copy);

        if (this.dataset.layout !== "marquee") viewport.scrollLeft = 0;
        this.dataset.layout = "marquee";
        const updatePause = () => {
          if (pause.hidden !== reducedMotion.matches) pause.hidden = reducedMotion.matches;
        };
        pause.addEventListener("click", () => {
          const paused = pause.getAttribute("aria-pressed") !== "true";
          pause.setAttribute("aria-pressed", String(paused));
          this.dataset.paused = String(paused);
        }, options);
        reducedMotion.addEventListener("change", updatePause, options);
        // Observer measurements already include layout; avoid synchronous reads
        // after enabling the marquee or changing its custom properties.
        this.observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            const property = entry.target === viewport ? "--reputation-viewport-width" : "--reputation-duration";
            const value = entry.target === viewport
              ? `${entry.contentRect.width}px`
              : `${entry.borderBoxSize[0].inlineSize / 20}s`;
            if (this.style.getPropertyValue(property) !== value) this.style.setProperty(property, value);
          });
        });
        this.observer.observe(viewport);
        this.observer.observe(logos, { box: "border-box" });
        updatePause();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.copy?.remove();
      }
    },
  );
}
